const modalStack = [];

const handlePushModal = ({ id }) => modalStack?.push(id);

const handlePopModal = ({ id }) => {
  const index = modalStack?.indexOf(id);
  if (index !== -1) modalStack?.splice(index, 1);
};

const handleIsTopModal = ({ id }) =>
  modalStack?.[modalStack?.length - 1] === id;

export { handleIsTopModal, handlePopModal, handlePushModal };
